// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_d27468fd","title":"_d5e42f6e","benefitsWrapper":"_9f6603d9","benefit":"_87949db9","icon":"_540ff745","cta":"_b846bb58"};